import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import PreferencePhraseSwitcher from './PreferencePhraseSwitcher';
import PhrasesActions from './PhrasesActions';
import PhrasesList from './PhrasesList';
import PhrasesTable from './PhrasesTable';
import { preferencesPhrasesStorage } from '../../services/preferencesPhrasesStorage';
import SearchItemBlock from '../../shared/SearchItemBlock';
import DownloadCSVFileButton from './DownloadCSVFileButton';
import CreateNewPreferenceButton from './CreateNewPreferenceButton';
import { useListViewMode } from '../../shared/listView/useListViewMode';
import ListViewSwitcher from '../../shared/listView/ListViewSwitcher';
import { DEFAULT_PHRASES_COUNT, TABLE_PHRASES_COUNT } from '../../constant';

const PreferencePhrasesTab = () => {
    const { i18n } = useTranslation();
    const { mode, setMode, isTableForcedOff } = useListViewMode('preference-phrase', { defaultMode: 'tile' });

    useEffect(() => {
        preferencesPhrasesStorage.setPageSize(
            mode === 'table' ? TABLE_PHRASES_COUNT : DEFAULT_PHRASES_COUNT,
        );
        preferencesPhrasesStorage.reloadPagesNumber();
    }, [mode]);

    useEffect(() => {
        return () => {
            preferencesPhrasesStorage.cleanStorage();
        };
    }, []);

    return (
        <>
            <DownloadCSVFileButton />
            <SearchItemBlock
                itemsStorageService={preferencesPhrasesStorage}
                placeholder={i18n.t('app.page.preference.preferenceSearch')}
                actions={
                    <>
                        <CreateNewPreferenceButton />
                        <ListViewSwitcher
                            mode={mode}
                            onChange={setMode}
                            disabled={isTableForcedOff}
                        />
                    </>
                }
            />
            <article className="preference__article preference__article_full-width preference__phrases-article">
                <div className='preference__phrases-wrapper'>
                    <PreferencePhraseSwitcher pageUrl={'/preference/item/list'} itemTitle={i18n.t('app.page.preference.phrase')} />
                    <PhrasesActions />
                </div>
                {mode === 'table' ? (
                    <PhrasesTable />
                ) : (
                    <PhrasesList skipInitialLoad />
                )}
            </article>
        </>
    );
};

export default PreferencePhrasesTab;
